import { FieldOkComponentStore } from '@softline/dynamic';

export const UmsatzstatistikFieldOkStore = { ...FieldOkComponentStore };
